<template>
  <div>
    <div class="tabs">
      <div 
        v-for="(item,index) in activeTabList" 
        :key="index" 
        @click="changeTab(item)" 
        :class="activeTab === item.active ? 'active_item tabsItem': 'tabsItem' "
      >
        <div style="z-index: 1;margin-bottom: 5px;">
          {{ item.name }}
           <span v-if="item.id == 1" style="margin-left: 8px;">¥{{info[item.type].total_amount || 0}}</span>
           <span v-if="item.id == 4" style="margin-left: 8px;">{{info.coupon.shengyu || 0}}张</span>
        </div>
        <div v-if="item.id == 1" class="info">
          <!-- <div style="display: flex;justify-content: space-between;"> -->
            <div> 本金：¥{{info[item.type].benjin || 0}}</div>
            <div> 赠金：¥{{info[item.type].zengjin || 0}}</div>
          <!-- </div> -->
          <div> 店转：¥{{info[item.type].dianzhuan || 0}}</div>
        </div>
        <div v-if="item.id == 2" class="info">
          <div> 余额：{{info.point.shengyu || 0}}积分</div>
          <div> 消耗：{{info.point.xiaofei || 0}}积分</div>
          <div> 累计：{{info.point.leiji || 0}}积分</div>
        </div>
        <div v-if="item.id == 3" class="info">
          <div>剩余：{{info.service.shengyu || 0}}张</div>
          <div>次卡：{{info.service.cika || 0}}张</div>
          <div>疗程卡：{{info.service.liaocheng || 0}}张</div>
        </div>
        <div v-if="item.id == 4" class="info">
          <div>满减券：{{info.coupon.manjian || 0}}张</div>
          <div>满赠券：{{info.coupon.manzeng || 0}}张</div>
          <div>兑换券：{{info.coupon.duihuan || 0}}张</div>
        </div>
      </div>
    </div>
    <div v-if="activeTab == 'assetFirst'">
      <moneyList  :clienId="clienId + ''"/>
    </div>
    <div v-if="activeTab == 'assetSecond'">
      <pointsList  :clienId="clienId + ''"/>
    </div>
    <div v-if="activeTab == 'assetThree'">
        <serveRecord  :clienId="clienId + ''" :detail="detail"/>
    </div>
    <div v-if="activeTab == 'assetFour'">
        <cardList :clienId="clienId + ''" :detail="detail" />
    </div>
  </div>
</template>

<script>
import serveRecord from '../../serve/serveList.vue'
import moneyList from './moneyList.vue'
import pointsList from './pointsList.vue'
import cardList from './couponList.vue'
import {surplusAccountCount} from '@/api/client'
export default {
  name: "ClientList",
  props: {
    clienId: {
      type: String,
      default: ""
    },
  detail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    serveRecord,
    pointsList,
    moneyList,
    cardList
  },
  data() {
    return {
      info:{},
      activeTab: 'assetFirst',
      activeTabList: [
        { name: '账户总额', type:'all',active: 'assetFirst', id: 1 },
        { name: '疤痕', type:'bahen',active: 'assetFirst', id: 1 },
        { name: '项目', type:'xiangmu',active: 'assetFirst', id: 1 },
        { name: '青春痘', type:'qingchun',active: 'assetFirst', id: 1 },
        { name: '护肤品', type:'hufupin',active: 'assetFirst', id: 1 },
        { name: '积分账户', active: 'assetSecond', id: 2 },
        { name: '服务卡项', active: 'assetThree', id: 3 },
        { name: '优惠券', active: 'assetFour', id: 4},
      ],
      activeBarStyle: {
        width: '0px',
        transform: 'translateX(0)'
      }
    };
  },
  mounted(){
    this.activeTab = this.$route.query.activeTab1 || 'assetFirst';

    this.getInfo()
  },
  methods: {
    changeTab(e) {
      this.activeTab = e.active;
    },
    getInfo(){
      surplusAccountCount({customer_id:this.clienId}).then(res=>{
        this.info = res.data
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.tabs {
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: 600;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  line-height: 20px;
  color: #33bea7;


  
  .tabsItem{
    width: 180px;
    border: 1px solid #33bea7;
    padding: 10px 12px;
    border-radius: 20px;
    min-width: 180px; /* 确保宽度不被内容压缩 */
  }
  
  div {
    cursor: pointer;
    position: relative;


    &::after {
      content: ''; // 必须设置content属性
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%; // 宽度与选项卡标签一致
      height: 100%;
      background: linear-gradient(to right, rgba(51, 190, 167, 1), rgba(51, 190, 167, 0.4));
      transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
      transform-origin: left;
      transform: scaleX(0); // 默认不显示
      border-radius: 20px;
    }
    .info{
      font-size: 13px;
       z-index: 1;
    }
  }
  
  .active_item {
    color: #fff;
    border: none;
    /* 显示高亮指示器 */
    &::after {
      transform: scaleX(1); // 完全显示
    }
  }
}
</style>
    